module.exports = __webpack_public_path__ + "static/media/auntie-whispers.5604ddda.png";